module.exports = __webpack_public_path__ + "static/img/moment2.5b5f522.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/moment2.png
// module id = 5YMj
// module chunks = 1